import { render, staticRenderFns } from "./TournamentTeamForm.vue?vue&type=template&id=690a163d&scoped=true"
import script from "./TournamentTeamForm.vue?vue&type=script&lang=js"
export * from "./TournamentTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a163d",
  null
  
)

export default component.exports